const vertexShader = `varying vec2 vUv;

void main() {

  mat4 mv = modelViewMatrix;

  mv[0][0] = 1.;
  mv[0][1] = 0.;
  mv[0][2] = 0.;

  mv[1][0] = 0.;
  mv[1][1] = 1.;
  mv[1][2] = 0.;

  mv[2][0] = 0.;
  mv[2][1] = 0.;
  mv[2][2] = 1.;

  gl_Position = projectionMatrix * mv * vec4( position, 1.0 );

  vUv = uv;
}`;

export default vertexShader;
